<template>
<footer>
    <div class="footer-bar">
        <div class="footer-content">
            <router-link to='/ultimos-pedidos'><span><history class="md-36"/></span></router-link>
            <v-popover offset="16" >
          <avatar :username="userName" :size=36></avatar>
          <template slot="popover">
            <div>
              <span>Bem vindo! {{ userName }}</span>
              <ul style="list-style: none;">
                <li>Crédito: {{ credito ? priceFormater(credito) : '0,00' }}</li> 
                <li v-if="vendedor">&nbsp;</li> 
                <li v-if="vendedor">Vendedor: {{ vendedor }}</li> 
                <li v-if="telefone">Telefone: {{ telefone }}</li> 
                <li>&nbsp;</li> 
                <li v-if="this.gestor =='S'">
                  <router-link style="color:white;" to='/acessos'> 
                    Acessos
                  </router-link>
                </li>
                <li  @click="logout()">
                 <span style="color:#fff;cursor: pointer;">Sair</span>
                </li>
              </ul>
            </div>
          </template>
        </v-popover>
            <!-- <span style="color:#FFF;margin-left: 8px;">{{ userName }}</span> -->
            <router-link to="/carrinho"><span><basket class="md-36"/></span></router-link>
        </div>
    </div>
</footer>
</template>

<script>
// import AccountCircle from "vue-material-design-icons/AccountCircle.vue";
import History from "vue-material-design-icons/History.vue";
import Basket from "vue-material-design-icons/Basket.vue";
import Avatar from 'vue-avatar';
import { userKey } from "@/global";

export default {
  name: 'Footer',
    components: {
      Avatar,
      History,
      Basket
  },
   data(){
    return{
       userName: '',
       gestor:'',
       vendedor: '',
       telefone: '',
       credito: 0
    }
  },
  methods:{
      logout(){
        localStorage.removeItem(userKey);
        localStorage.removeItem('vendedor');
        localStorage.removeItem('cliente_usuario_vinculado');
        this.$store.commit('removeUser');
        this.$router.push({name: 'home'});
    },
    priceFormater(valor){
      return valor.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    },
  },
  created(){
    const json = localStorage.getItem(userKey);
    const userData = JSON.parse(json);
    this.userName = userData.userName;
    this.gestor = userData.gestor;
    this.credito = userData.credit;
    this.vendedor = userData.vendedor;
    this.telefone = userData.telefone;
  }
}
</script>

<style scoped>
footer{
  position: fixed;
  bottom: 0;
  width: 100%;
  z-index: 99;
  
}

.footer-bar{
  background-color: #25365C;
  height: 50px;
}

.footer-content{
  display: flex;
  text-align: center;
  height: 100%;
  align-items: center;
  justify-content: space-between;
}

.footer-content p{
  color: white;
}

.footer-content a{
  width: 33.3333%;
  color: white;
}

  footer{
    display: none;
  }

/* media queries */

@media screen and (max-width: 900px) {
  footer{
    width: 100%;
     display: inherit;
  }
}

@media screen and (max-width: 900px) and (min-width: 600px) {

}
</style>
